import * as z from "zod/v4";

/** Mirrors the CRDB `pricing_inclusion_mode` enum on `redo_market`. */
export const pricingInclusionMode = z.enum([
  "none",
  "duties_only",
  "taxes_only",
  "duties_taxes",
]);
